import moment from 'moment-jalaali';
import { SpaceBetween } from 'utils/style/extendable';
import { IUsers } from 'store/users/usersType';
import {
  IAnswersView,
  IMultipleChoiceQuestionView,
  IQuestionsView,
  ISurveyResponseView,
} from 'store/survey/surveyTypes';
import HoverIcon from 'components/HoverIcon';
import AnswerView from 'components/FileManager/ItemsViewer/Survey/SurveyResponseViewer/AnswerView';
import DistinctiveAnswers from 'components/DistinctiveAnswers';
import {
  Bold,
  Header,
  MyBadge,
} from 'components/FileManager/ItemsViewer/Survey/SurveyResponseViewer/styles';
import { convertDigitToProperFormat } from 'utils/number';
import Collapsible from 'components/Collapsible';
import { ViewList, ResponsesBody } from './styles';
import { ITags } from 'store/providers/providerTypes';
import { getLanguageBaseOnTZ } from '../../../utils/LanguageLocalStorage';

interface IComponentProps {
  tags: ITags['data'];
  users: IUsers['map'];
  question: IQuestionsView;
  responses: Array<ISurveyResponseView>;
  selectedTags: number[];
  gridPartValue?: string;
  selectedChoices: Array<string | number>;
  onCloseQuestion: () => void;
  distinctiveQuestions?: IMultipleChoiceQuestionView[];
  providerId: number | undefined;
}

const ResponsesOfQuestion: React.FC<IComponentProps> = ({
  tags,
  users,
  question,
  responses,
  selectedTags,
  gridPartValue,
  selectedChoices,
  onCloseQuestion,
  distinctiveQuestions,
  providerId,
}) => {
  const lang = getLanguageBaseOnTZ();
  return (
    <ViewList>
      <Header>
        <Bold>{question.title}</Bold>
        <HoverIcon type="x" color="white" onClick={onCloseQuestion} />
      </Header>
      <ResponsesBody>
        {Object.values(responses)
          .sort((a, b) => {
            if (b.submitDate && a.submitDate)
              return b.submitDate - a.submitDate;

            return 0;
          })
          .map((response) => {
            if (response) {
              const questionAnswer = response.surveyAnswerList.find(
                (answer: IAnswersView) => {
                  if (selectedChoices.length > 0 && answer.type === 'grid') {
                    return (
                      answer.questionId === question.id &&
                      selectedChoices.find((value) => value === answer.value)
                    );
                  } else if (
                    selectedChoices.length > 0 &&
                    answer.type === 'multipleChoice'
                  ) {
                    return (
                      answer.questionId === question.id &&
                      selectedChoices.find((value) => value === answer.value)
                    );
                  }
                  return answer.questionId === question.id;
                }
              );
              if (questionAnswer) {
                return (
                  <Collapsible
                    key={response.id}
                    defaultOpen={true}
                    customHeaderStyle={{ flexGrow: 1 }}
                    style={{
                      marginInlineStart: '0.5rem',
                    }}
                    header={
                      <SpaceBetween>
                        <span>{users[response.userId!]?.name}</span>
                        <div style={{ display: 'flex' }}>
                          {distinctiveQuestions ? (
                            <DistinctiveAnswers
                              answers={response.surveyAnswerList}
                              questions={distinctiveQuestions}
                              tags={tags}
                            />
                          ) : null}
                          <MyBadge hollow={true} color="blue">
                            {lang === 'fa'
                              ? convertDigitToProperFormat(
                                  moment(response.submitDate).format(
                                    'jD jMMMM jYYYY'
                                  )
                                )
                              : convertDigitToProperFormat(
                                  moment(response.submitDate)
                                    .locale('en')
                                    .format('MMMM D YYYY')
                                )}
                          </MyBadge>
                        </div>
                      </SpaceBetween>
                    }
                  >
                    <AnswerView
                      answer={questionAnswer}
                      question={question}
                      selectedTags={selectedTags}
                      gridPartValue={gridPartValue}
                      selectedChoices={selectedChoices}
                      providerId={providerId}
                    />
                  </Collapsible>
                );
              }
              return null;
            }
            return null;
          })}
      </ResponsesBody>
    </ViewList>
  );
};

export default ResponsesOfQuestion;
